import React, { Dispatch, SetStateAction } from 'react';
import { Header } from '../header';
import { IconChevron } from '../../assets/icons/icon-chevron';
import './index.scss';

type RangeHeaderProps = {
  prevAvailable: boolean;
  nextAvailable: boolean;
  range: string;
  setPage: Dispatch<SetStateAction<number>>;
};

export const RangeHeader: React.FC<RangeHeaderProps> = ({ prevAvailable, nextAvailable, range, setPage }) => (
  <div className="analyse-range-header" style={{ display: 'flex', alignItems: 'center' }}>
    <button disabled={!prevAvailable} onClick={() => setPage((prev) => prev - 1)}>
      <IconChevron />
    </button>
    <Header title={range} center />
    <button disabled={!nextAvailable} onClick={() => setPage((prev) => prev + 1)}>
      <IconChevron direction="right" />
    </button>
  </div>
);
